import { TFunction } from 'i18next';
import {
  Dashboard,
  ReceiptLong,
  People,
  Person,
  HelpOutline,
} from '@styled-icons/material-outlined';
import { NavItemConfig } from './NavBar.types';
import { routes } from '../../routes';

export const getNavItems = (t: TFunction, isAggregatorAccount: boolean): NavItemConfig[] => [
  {
    title: t('common:home'),
    path: routes.platform.home,
    icon: Dashboard,
    exact: true,
    hidden: isAggregatorAccount,
  },
  {
    title: t('settingsMe:title'),
    path: routes.platform.settings.profile,
    icon: Person,
    exact: true,
    hidden: isAggregatorAccount,
  },
  {
    title: t('settingsUsers:title'),
    path: routes.advanced.index,
    icon: People,
    exact: true,
  },
  {
    title: t('common:billing'),
    path: routes.invoices.index,
    icon: ReceiptLong,
    hidden: isAggregatorAccount,
    children: [
      {
        title: 'Tus facturas',
        path: routes.invoices.index,
        exact: true,
      },
      {
        title: t('billing:billingSettings'),
        path: routes.invoices.settings.billing,
      },
      {
        title: t('billing:availablePaymentMethods'),
        path: routes.invoices.settings.paymentMethods,
      },
    ],
  },
  {
    title: 'Soporte',
    path: routes.support,
    icon: HelpOutline,
    hidden: isAggregatorAccount,
  },
];
